<template>
  <div>
    <!-- <v-btn @click="check">Check</v-btn> -->
    <v-col cols="12">
      <v-dialog
        v-model="dialog"
        max-width="85hw"
        v-if="roles.create_announcement"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on"
            >Add Announcement</v-btn
          >
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-col cols="12" v-if="error">
                <v-alert type="error" style="text-align: left">
                  {{ informText }}
                </v-alert>
              </v-col>
              <v-col cols="12">
                <v-row>

                  <v-col cols="6">
                    <v-select
                      :items="userRoles"
                      v-model="data.to_roles"
                      label="Select Role(s)"
                      dense
                      chips
                      multiple
                      outlined
                      @change="validation"
                      hide-details
                    ></v-select>
                  </v-col>

                  <v-col cols="6">
                    <v-select
                      v-model="data.to_usernames"
                      :items="listUser"
                      :item-text="(obj) => obj.username"
                      :item-value="(obj) => obj.username"
                      label="Select User(s)"
                      chips
                      multiple
                      dense
                      outlined
                      hide-details
                      @change="validation"
                    ></v-select>
                  </v-col>

                  <v-col cols="12">
                    <ckeditor
                      v-model="inputText" 
                      :editor="editor"
                      :config="editorConfig"></ckeditor>
                  </v-col>
                  
                </v-row>
              </v-col>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <!-- <v-btn color="blue darken-1" text @click="check">Check</v-btn> -->
            <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="save"
              v-if="showBtn == true"
              type="submit"
              >Save</v-btn
            >
            <v-btn color="blue darken-1" text v-else disabled="">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>

    <v-row>
      <v-col cols="12">
        <v-col cols="12" v-for="(i, index) of announcementsData" :key="index">
          <v-card class="mx-auto" style="text-align: left">
            <v-card-text>
              <div>{{ i.created_date }}</div>
              <p
                v-html="i.message"
                class="border"
                style="border-radius: 10px; padding: 10px"
              ></p>
              <p><b>From: </b>{{ i.created_user }}</p>
              <p><b>To:</b></p>
              <p v-if="i.to_usernames.length > 0">
                User(s): {{ i.to_usernames.join(", ") }}
              </p>
              <p v-if="i.to_roles.length > 0">
                Role(s): {{ i.to_roles.join(", ") }}
              </p>
            </v-card-text>

            <v-card-actions>
              <v-btn
                outlined
                rounded
                text
                color="info"
                @click="editItem(i)"
                v-if="roles.update_announcement"
              >
                Edit
              </v-btn>
              <v-btn
                outlined
                rounded
                text
                color="red"
                @click="deleteItem(i)"
                v-if="roles.delete_announcement"
              >
                Delete
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-col>
    </v-row>
  </div>
</template>


<script>
import axios from "axios";
//import Vue from "vue";
//import HTTP from "../http-common"
import moment from "moment-timezone";
import Amplify, { Auth } from "aws-amplify";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  name: "Sites",
  //new Vue({
  data: () => ({
    search: "",
    inputText: "",
    dialog: false,
    showBtn: false,
    error: null,
    indexItem: "",
    editor: ClassicEditor,
    editorConfig: {
      // todo confg
    },
    data: {
      _id: "",
      message: "",
      to_usernames: [],
      to_roles: [],
    },
    announcementsData: [],
    loading: false,
    listUser: [],
    userRoles: [],
    roles: [],
  }),

  computed: {
    formTitle() {
      return this.data._id === "" ? "New Announcement" : "Edit Announcement";
    },
  },

  watch: {
    inputText() {
      this.data.message = this.inputText;
      this.validation();
    },
    dialog(val) {
      val || this.close();
      this.error = null;
      this.informText = "";
      this.validation();
    },
  },

  methods: {
    async loadData() {
      //this.loading = true;
      var currentSession = await this.$root.$refs.App.currentSession(
        "announcement-loadData"
      );
      if (currentSession.accessToken) {
        await axios
          .get(window.domain + "announcements", {
            headers: { Authorization: currentSession.accessToken },
          })
          .then((response) => {
            // If request is good...
            console.log("response: ", response);
            this.announcementsData = response.data.data.announcements;
            this.userRoles = response.data.data.roles;
            for (const i of this.announcementsData) {
              i.created_date = moment(i.created_date)
                .tz("Asia/Ho_Chi_Minh")
                .format("DD/MMM/YYYY - HH:mm");
            }
            //this.loading = false;
          })
          .catch((error) => {
            console.log("error ", error);
          });

        await axios
          .get(window.domain + "users", {
            headers: { Authorization: currentSession.accessToken },
          })
          .then((response) => {
            // If request is good...
            console.log("response: ", response);
            this.listUser = response.data.data.users;
            //this.loading = false;
          })
          .catch((error) => {
            console.log("error ", error);
          });
      } else {
        console.log(
          "currentSession announcement-loadData-undefined: ",
          currentSession
        );
      }
    },

    editItem(item) {
      this.indexItem = this.announcementsData.indexOf(item);
      this.data = Object.assign({}, item);
      this.inputText = this.data.message;
      this.dialog = true;
    },

    async deleteItem(item) {
      var index = this.announcementsData.indexOf(item);
      var r =
        confirm("Are you sure you want to delete this announcement?") &&
        this.announcementsData.splice(index, 1);
      console.log(item);
      if (r != false) {
        var currentSession = await this.$root.$refs.App.currentSession(
          "announcement-delete"
        );
        //console.log('currentSession: ',currentSession.accessToken)
        if (currentSession.accessToken) {
          axios
            .delete(window.domain + "announcements/" + item._id, {
              headers: { Authorization: currentSession.accessToken },
            })
            .then((response) => {
              this.loadData();
              console.log("delete response: ", response);
            })
            .catch((error) => {
              console.log("Error:", error);
            });
        } else {
          console.log(
            "currentSession announcement-delete-undefined: ",
            currentSession
          );
        }
      }
    },

    close() {
      this.dialog = false;
      this.indexItem = "";
      this.data = {
        _id: "",
        message: "",
        to_usernames: [],
        to_roles: [],
      };
      this.inputText = "";
    },

    validation() {
      if (
        (this.data.to_usernames.length > 0 || this.data.to_roles.length > 0) &&
        this.data.message != ""
      ) {
        this.showBtn = true;
      } else {
        this.showBtn = false;
      }
    },

    async save() {
      var currentSession = await this.$root.$refs.App.currentSession(
        "announcement-saveData"
      );
      //console.log('currentSession: ',currentSession.accessToken)
      if (currentSession.accessToken) {
        if (this.data._id != "") {
          //var a = Object.assign(this.sites[this.editedIndex], this.editedItem)
          console.log(this.data);
          await fetch(window.domain + "announcements/" + this.data._id, {
            method: "PUT",
            headers: { Authorization: currentSession.accessToken },
            body: JSON.stringify(this.data),
          })
            .then((response) => response.json())
            .then((data) => {
              console.log("edit announcement response: ", data);
              if (data.error_message == "") {
                this.loadData();
                this.close();
                this.informText = "";
                //Object.assign(this.announcementsData[this.indexItem], data.data)
              } else {
                this.error = true;
                this.informText = data.error_message;
              }
            })
            .catch((error) => console.log(error));
        } else {
          await fetch(window.domain + "announcements", {
            method: "POST",
            headers: { Authorization: currentSession.accessToken },
            body: JSON.stringify(this.data),
          })
            .then((response) => response.json())
            .then((data) => {
              console.log("add announcement response: ", data);
              if (data.error_message == "") {
                this.loadData();
                this.close();
              } else {
                this.error = true;
                this.informText = data.error_message;
              }
            })
            .catch((error) => console.log("Err: ", error));
        }
        //this.close()
      } else {
        console.log(
          "currentSession announcement-saveData-undefined: ",
          currentSession
        );
      }
    },

    check() {
      console.log(this.data);
    },

    checkRoles(str) {
      var a = this.$root.$refs.App.hashCode(str);

      if (this.$cookies.get("roles") != null) {
        var role = this.$cookies.get("roles").split(",");
        var index = role.indexOf(a.toString());
        if (index != -1) return true;
        else return false;
      } else return false;
    },
  },
  async mounted() {
    this.roles = await this.$cookies.get("announcement");
    if (this.roles.list_announcements) {
      console.log("OK");
    } else {
      this.$router.push("/not-authorized");
    }

    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });
      this.loadData();
    } catch (error) {
      console.log("User logged out!");
      this.$router.push("/login");
    }
  },
};
</script>

<style scoped>
.cke_top .cke_bottom {
  display: none !important;
}
</style>